import Card from "./components/UI/Card/Card";

function App() {
  return (
    <main className="flex items-center justify-center h-screen px-6 bg-dark-blue-main">
      <Card />
    </main>
  );
}

export default App;
